import { c as _c } from "react/compiler-runtime";
import './blockquote.scss';
import * as z from 'zod';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { Image } from '../../atoms/image/image.tsx';
const LinkedSourceWrapper = t0 => {
  const $ = _c(3);
  const {
    primaryCTA,
    body
  } = t0;
  let t1;
  if ($[0] !== body || $[1] !== primaryCTA) {
    t1 = primaryCTA?.link ? <Link href={primaryCTA.link} title={primaryCTA.title}>{body}</Link> : body;
    $[0] = body;
    $[1] = primaryCTA;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const getBlockquoteVariant = ({
  quotation
}: FlexibleContentProps) => {
  if (quotation?.image) {
    return 'avatar';
  }
  if (quotation?.primaryCTA) {
    return 'linked';
  }
  return 'default';
};
export const BlockquoteProps = FlexibleContentProps.extend({
  size: z.enum(['sm', 'md', 'lg', 'xs', 'inherit']).optional()
});
export type BlockquoteProps = z.infer<typeof BlockquoteProps>;
export const Blockquote = t0 => {
  const $ = _c(13);
  const {
    quotation,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const quotationText = `“${quotation?.text}”`;
  const t2 = size === "lg" ? "gap-comfy-xl" : "gap-comfy-md";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("Blockquote py-snug-xl pl-comfy-md flex flex-col", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `Blockquote__quotation emphasis emphasis-${size}`;
  let t5;
  if ($[2] !== t4) {
    t5 = cn(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== quotationText || $[5] !== t5) {
    t6 = <blockquote className={t5}>{quotationText}</blockquote>;
    $[4] = quotationText;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== quotation) {
    t7 = (quotation?.attribution || quotation?.title) && <figcaption className={cn(`Blockquote__citation Blockquote__citation--${getBlockquoteVariant({
      quotation
    })}`, quotation?.title && "has-title")}><LinkedSourceWrapper primaryCTA={quotation?.primaryCTA} body={<div className="flex gap-snug-xl items-center">{quotation?.image?.url && <Image image={quotation?.image} rounded="full" aspectRatio="1" className="mr-snug-sm" />}{quotation?.primaryCTA?.link && <ArkIcon iconName="link-01" size="1.5rem" />}<div className="label-moderate label-lg"><div className="Blockquote__attribution">{quotation?.attribution}</div>{quotation?.title && <div>{quotation?.title}</div>}</div></div>} /></figcaption>;
    $[7] = quotation;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t3 || $[10] !== t6 || $[11] !== t7) {
    t8 = <figure className={t3}>{t6}{t7}</figure>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};